import styled from 'styled-components';
import fontService, { FontWeight } from 'services/FontService';

export const WindowBurnCard = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 4;
  background: linear-gradient(180deg, rgba(18, 16, 17, 0.6) 40%, #121011 100%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WindowBurnCardContent = styled.div<{
  backgroundColor: string;
  borderColor: string;
}>`
  background: #2b2a2b;
  height: 280px;
  padding: 24px 64px 48px;
  border-radius: 12px;
  background: ${({
    backgroundColor,
  }) => `linear-gradient(180deg, ${backgroundColor} 0%, #171516 64%),
    linear-gradient(0deg, #1b191a, #1b191a)`};
  border: ${({ borderColor }) => `1px solid${borderColor}`};
  text-align: center;
  min-width: 388px;
  width: 388px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

export const WindowShuffleContent = styled(WindowBurnCardContent)`
  padding: 48px 64px;
  height: fit-content;
`;

export const BurnCardText = styled.div`
  ${fontService.getFont({ size: 32, lineHeight: 130, weight: FontWeight.bold })};
  color: #fff7eb;
  text-transform: uppercase;
  width: 110px;
  margin-left: 12px;
`;

export const ShuffleText = styled.div`
  ${fontService.getFont({ size: 32, lineHeight: 130, weight: FontWeight.bold })};
  text-transform: uppercase;
  color: #fff7eb;
  margin-bottom: 32px;
  margin-top: 10px;
`;

export const BurnCardAmount = styled.p`
  ${fontService.getFont({ size: 116, lineHeight: 100, weight: FontWeight.bold })};
  text-transform: uppercase;
  position: relative;
  top: 11px;
  left: 0;
`;

export const BurnCardContent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 32px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin: auto;
`;
